import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card'

interface SummaryProps {
  overview: string
  keyFindings: string[]
  participationStats: {
    roles: string[]
  }
}

export function SummarySection({ overview, keyFindings, participationStats }: SummaryProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Executive Summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <p className="text-muted-foreground">{overview}</p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div>
            <h4 className="font-medium mb-2">Key Findings</h4>
            {keyFindings?.length > 0 ? (
              <ul className="list-disc list-inside space-y-2">
                {keyFindings.map((finding, index) => (
                  <li key={index} className="text-sm text-muted-foreground">
                    {finding}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-muted-foreground">No key findings available</p>
            )}
          </div>

          <div>
            <h4 className="font-medium mb-2">Participating Roles</h4>
            {participationStats.roles?.length > 0 ? (
              <ul className="list-disc list-inside space-y-2">
                {participationStats.roles.map((role, index) => (
                  <li key={index} className="text-sm text-muted-foreground">
                    {role}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-muted-foreground">No participation data available</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}